import { useCallback } from 'react';
import { getTranslation } from '../helpers';
import { useTranslations } from './useTranslations';

export const useTranslate = () => {
    const translations = useTranslations();

    return useCallback((key, parameters) => getTranslation(
        key,
        parameters,
        translations
    ), [translations]);
};
